import { useState, useEffect } from "react";

// Seconds elapsed since startedAt (an ISO instant, or null when no timer is
// running), always recomputed from the wall clock.
//
// It deliberately never accumulates ticks: browsers throttle timers in a
// hidden tab - Chrome down to one tick a minute after five minutes - and
// missed ticks are never made up, so a counter falls silently behind (issue
// #1). The interval below only forces a re-render, and visibilitychange
// forces one more the instant the tab comes back, so the display is right
// immediately rather than up to a second later.
const useElapsed = (startedAt) => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!startedAt) return;
    const tick = () => setNow(Date.now());
    tick();
    const interval = setInterval(tick, 1000);
    document.addEventListener("visibilitychange", tick);
    return () => {
      clearInterval(interval);
      document.removeEventListener("visibilitychange", tick);
    };
  }, [startedAt]);

  if (!startedAt) return 0;
  const secs = Math.floor((now - new Date(startedAt).getTime()) / 1000);
  return secs > 0 ? secs : 0;
};

export default useElapsed;
